import { mergePlain } from 'util/merge'
import { doGraphqlRequest, doRequest } from 'ducks/requests/operations'
import { buildId } from 'util/globalId'
import {
  MERGE_AND_RELOAD_CONVERSATION,
  MERGE_CONVERSATION,
} from '../actionTypes'
import { updateMergeConversationMutation } from '../mutations'
import { CONVERSATION_SAVE_UNLOAD_MESSAGE } from '../constants'
import { selectCurrentConversationById } from '../selectors'
import { conversationMergeGraphQlResponseSchema } from '../schema'
import { doFetchTicketEventGroups } from './doFetchTicketEventGroups'

const defaultMergeFailureMessage = () =>
  `Oops, we couldn't merge your ${app.t('ticket')}.`

const throwOnConversationMergeErrors = data => {
  const errors = data?.conversationMerge?.errors || []

  if (errors.length === 0) return data

  const error = new Error(errors[0]?.message || defaultMergeFailureMessage())
  error.errors = errors
  throw error
}

export const doMerge = (targetTicketId, sourceTicketId, options = {}) => (
  dispatch,
  getState
) => {
  const sourceConversationId = buildId('Conversation', sourceTicketId)
  const targetConversationId = buildId('Conversation', targetTicketId)

  const state = getState()
  const sourceTicket = selectCurrentConversationById(state, sourceTicketId)
  const targetTicket = selectCurrentConversationById(state, targetTicketId)
  if (!sourceTicket || !targetTicket) return null

  return dispatch(
    doRequest(
      MERGE_AND_RELOAD_CONVERSATION,
      async () => {
        const transformResponse = (data, store, requestOptions) => {
          const mergeData = throwOnConversationMergeErrors(data)

          return options.transformResponse
            ? options.transformResponse(mergeData, store, requestOptions)
            : mergeData
        }
        const requestOptions = mergePlain(
          {
            app: true,
            throwOnError: true,
            concurrency: {
              key: targetTicketId,
              message: CONVERSATION_SAVE_UNLOAD_MESSAGE,
            },
            normalizationSchema: conversationMergeGraphQlResponseSchema,
            moduleOptions: {
              snackbar: {
                enabled: true,
                success: {
                  enabled: true,
                  message: `${app.t('Ticket')} merged`,
                },
                failed: {
                  enabled: true,
                  message: error =>
                    error?.message || defaultMergeFailureMessage(),
                },
              },
              entities: {
                additionalActions: [
                  {
                    entityType: 'conversation',
                    entityId: sourceTicketId,
                    stores: ['pending', 'current'],
                    operation: 'remove',
                    phases: ['SUCCESS'],
                  },
                ],
              },
            },
            meta: {
              mergeEntities: true,
            },
          },
          options
        )
        requestOptions.transformResponse = transformResponse

        const response = await dispatch(
          doGraphqlRequest(
            MERGE_CONVERSATION,
            updateMergeConversationMutation(),
            {
              sourceConversationId,
              targetConversationId,
            },
            requestOptions
          )
        )
        await dispatch(doFetchTicketEventGroups(targetTicketId, options))
        return response
      },
      {
        sourceConversationId,
        targetConversationId,
      },
      mergePlain(
        {
          throwOnError: true,
        },
        options
      )
    )
  )
}
